import { render, staticRenderFns } from "./Play_Duration.vue?vue&type=template&id=2de23e46&scoped=true"
import script from "./Play_Duration.vue?vue&type=script&lang=js"
export * from "./Play_Duration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de23e46",
  null
  
)

export default component.exports